import React, { Fragment } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Link as RouterLink } from "react-router-dom";

import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import useApp from 'app/context/useApp';

const useStyles = makeStyles(theme => ({
    form: {
        maxWidth: '320px'
    },
    marginBottom: {
        marginBottom: theme.spacing(3),
    },
    marginTop: {
        marginTop: theme.spacing(3),
    },
}));

export default function LoginSupport (props) {

    const classes = useStyles();

    const { app } = useApp();

    return (
        <div className={classes.form}>
            <Typography component="div" variant="subtitle1" className={classes.marginBottom}>
                If you are unable to login, please use the resources below to help locate the appropriate credentials.
            </Typography>
            {app.club ? (
                <Fragment>
                    <div className={classes.marginBottom}>
                        <Typography component="div" variant="subtitle2" gutterBottom>
                            Support Email:
                        </Typography>
                        <Typography component="div" variant="subtitle1" color="textSecondary" gutterBottom>
                            <Link
                                href={"mailto:" + app.club.support_email}
                                target="_blank"
                                color="secondary"
                                >
                                {app.club.support_email}
                            </Link>
                        </Typography>
                    </div>
                    {(app.club.support_phone && app.club.support_phone != "") &&
                        <div className={classes.marginBottom}>
                            <Typography component="div" variant="subtitle2" gutterBottom>
                                Support Phone:
                            </Typography>
                            <Typography component="div" variant="subtitle1" color="textSecondary" gutterBottom>
                                <Link
                                    href={"tel:" + app.club.support_phone}
                                    target="_blank"
                                    color="secondary"
                                    >
                                    {app.club.support_phone}
                                </Link>
                            </Typography>
                        </div>
                    }
                </Fragment>
            ) : (
                <Fragment>
                    <Typography component="div" variant="subtitle2" gutterBottom>
                        Please contact Club Apps directly using the following email address:
                    </Typography>
                    <Typography component="div" variant="subtitle1" color="textSecondary" gutterBottom>
                        <Link href={"mailto:" + process.env.MIX_CA_SUPPORT_EMAIL} target="_blank">{process.env.MIX_CA_SUPPORT_EMAIL}</Link>
                    </Typography>
                </Fragment>
            )}
            <Button
                component={RouterLink}
                to="/login"
                variant="outlined"
                color="secondary"
                fullWidth
                className={classes.submit}
                >
                Back to Login
            </Button>
        </div>
    );
}
